module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand-app",
    attrs: {
      "id": "app"
    }
  }, [_c('w-loading', {
    attrs: {
      "bg-color": "rgba(255,255,255,0.8)",
      "text": "正在加载...",
      "is-show": _vm.getShowLoading,
      "color": "#00a0f3",
      "font-size": 14,
      "spinner-width": 30,
      "spinner-height": 30,
      "spinner-type": 6
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('router-view', {
    staticClass: "child-view"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b150041"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 244
// module chunks = 92